import axios from "axios";
import store from "@/store";
// export const getCookie = key => {
//   var v = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
//   return v ? v[2] : null;
// };

// export const getJWT = () => {
//   return getCookie("jwt");
// };

let baseURL =
  process.env.NODE_ENV == "development"
    ? `http://localhost:4000`
    : `https://whenshitbreaks.com`;

const instance = axios.create({
  baseURL
  // headers: {
  //   withCredentials: true
  // }
});

instance.interceptors.request.use(config => {
  if (store.state && store.state.user && store.state.user.token) {
    config.headers["Authorization"] = `Bearer ${store.state.user.token}`;
  }

  // if (process.env.NODE_ENV == "development") {
  //   config.headers["Authorization"] = `Bearer ${getCookie("jwt")}`;
  // }
  return config;
});

export default instance;
